// Packages
import { Component, h, Host, Prop } from "@stencil/core";
import { TThemeColors } from "../../interface";

/**
 * `fx-kbd` is a headless, accessible keyboard-key component. It renders a
 * native `<kbd>` element, exposes every styleable surface via `part`
 * attributes, and reflects its state through `data-*` attributes so themes
 * can customize it without internal styles.
 *
 * @slot - The key label. Used as a fallback when `value` is not set.
 *
 * @part base - The native `<kbd>` element.
 */
// `styleUrl` is intentionally omitted (no internal styles per AGENTS.md).
@Component({
  tag: "fx-kbd",
  shadow: true,
})
export class FxKbd {
  // --------------------------------------------
  // Props
  // --------------------------------------------

  /**
   * @prop - The text label of the key. When omitted, the default slot is
   * rendered instead.
   */
  @Prop()
  value?: string;

  /**
   * @prop - The color theme of the key. Reflects to `data-color` on the host.
   */
  @Prop()
  color?: TThemeColors;

  /**
   * @prop - The visual style of the key. Reflects to `data-variant` on the
   * host.
   */
  @Prop()
  variant?: "outline" | "soft" | "subtle" | "solid";

  // --------------------------------------------
  // Render
  // --------------------------------------------

  render() {
    return (
      <Host
        data-color={this.color}
        data-variant={this.variant}
      >
        <kbd part="base">
          {this.value || <slot />}
        </kbd>
      </Host>
    );
  }
}
